var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 68,
    viewBox: "0 0 115 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.6562 25L79.3229 36.6667H114.323V67H53.6562V32L58.3229 25H88.6562Z",
    fill: "#FF9100",
    stroke: "#1B2228"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3281 36.6667V67H60.6615V36.6667L53.6615 25H16.3281L23.3281 36.6667Z",
    fill: "#FFB32B",
    stroke: "#1B2228"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 36.6667L16.3333 25H53.6667L60.6667 36.6667M35 36.6667H114.333V67H0",
    stroke: "#1B2228"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6797 36.6582V66.9915M79.3463 36.6582V66.9915M88.6797 36.6582V66.9915",
    stroke: "#1B2228"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 11.5L43 13L46.5 10",
    stroke: "#07BD81",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37 1L38.5 4M34 4L37.5 5.5M33.5 8L37.5 7.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2929 14.8484L43.6667 19.2222L43.6809 19.2364C44.0928 19.6483 44.7681 19.6224 45.1472 19.1801L48.8704 14.8364C49.0257 14.6552 49.1111 14.4243 49.1111 14.1856V7C49.1111 6.44772 48.6634 6 48.1111 6H40C39.4477 6 39 6.44772 39 7V14.1413C39 14.4066 39.1054 14.6609 39.2929 14.8484Z",
    stroke: "#1B2228"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHeader);
export default __webpack_public_path__ + "static/media/orderHeader.f36e1f47772400c3c7126bc80859fb1b.svg";
export { ForwardRef as ReactComponent };